import React from "react";
import HolidayStatisticsOverview from "../statistics-overview/statistics-overview";
import HolidayListView from "../holiday-list-view/holiday-list-view";
import CalendarView from "../calendar-view/calendar-view";
import { deleteHoliday } from "../../../../services/holiday_leave";

const HolidayMainView = (props) => {
  const {
    activeView, 
    onEditHoliday,
    overviewStatistics,
    holidayList,
    loading,
    fetchHolidayData,
  } = props;

  const handleDelete = async (id) => {
    await deleteHoliday(id);
    fetchHolidayData();
  };

  return (
    <div>
      <HolidayStatisticsOverview 
        overviewStatistics={overviewStatistics} 
        loading={loading}
      />
      {activeView === "list" ? (
        <HolidayListView
          handleEditHoliday={onEditHoliday}
          handleDeleteHoliday={handleDelete}
        />
      ) : (
        <CalendarView holidayList={holidayList} />
      )}
    </div>
  );
};

export default HolidayMainView;
